// const Cookie = require('js-cookie')
// import _ from 'lodash'

export default ({
  namespaced: true,
  state: {
    me: {},
    appointment: {},
    permissions: '',
    auth: {},
    axiosHeaders: {}
  },
  mutations: {
    SET_AUTH (state, data) {
      state.auth = data
      localStorage.setItem('auth', JSON.stringify(data)) // save token in localStorage
      state.axiosHeaders = {
        Authorization: `Bearer ${data.access}`
      }
      // this._vm.$axios.defaults.headers.common['Authorization'] = `Bearer ${data.access}`
    },
    SET_ME (state, data) {
      state.me = data
    },
    SET_APPOINTMENT (state, { appointment, raw }) {
      if (!appointment) {
        appointment = {
          organization: raw.organization,
          profession: {
            id: raw.profession.id,
            name: raw.profession.name,
            title: raw.profession.title
          }
        }
      }
      state.appointment = appointment
      localStorage.setItem('appointment', JSON.stringify(appointment))
    },
    SET_PERMS (state, data) {
      /*
      ['app.operation_model_filter', ...] to
      {
        app: {
          model: ['operation', ...]
          ...
        }
        ...
      }
      */
      const perms = data.profession.permissions
      state.permissions = perms.reduce((acc, perm) => {
        try {
          const app = perm.app

          acc[app] = perm.permissions.reduce((acc1, perm1) => {
            const prm = perm1.split('_')
            const model = prm[1]
            if (model in acc1 === false) acc1[model] = []
            const operation = prm.length > 2 ? `${prm[0]}_${prm[2]}` : prm[0]
            if (acc1[model].includes(operation) === false) acc1[model].push(operation)
            return acc1
          }, {})
          return acc
        } catch (error) {
          console.log(error)
          return acc
        }
      }, {})
    }
  },
  actions: {
    async login ({ commit }, login) {
      return await this._vm.$axios.post('/auth/token/', login)
        .then(res => {
          commit('SET_AUTH', res.data) // mutating to store for client rendering
          return res.data
        })
    },
    async refreshToken ({ state, commit }) {
      return await this._vm.$axios.post('/auth/token/refresh/', {
        refresh: state.auth.refresh
      })
        .then(res => {
          if ('access' in res.data) {
            const auth = {
              access: res.data.access,
              refresh: state.auth.refresh
            }
            commit('SET_AUTH', auth) // mutating to store for client rendering
          }
          return res.data
        })
    },
    async getMe ({ state, commit, dispatch }) {
      return await this._vm.$axios.get('/users/user/me/', { headers: state.axiosHeaders })
        .then((me) => {
          if (me) {
            try {
              if (state.appointment.profession?.name) {
                // set perms for current appointment
                commit('SET_PERMS', me.data.appointments.filter(appointment => appointment.profession.name === state.appointment.profession.name)[0])
              } else {
                // set first appointment && perms
                console.log(me.data.appointments[0])
                commit('SET_APPOINTMENT', { raw: me.data.appointments[0] })
                commit('SET_PERMS', me.data.appointments[0])
              }
            } catch (error) {
              console.log(error)
            }
            commit('SET_ME', me.data)
          }
          return me.data
        })
    },
    checkAuth ({ commit }) {
      // проверка localStorage, если есть устанавливаем, если нет, то store.auth = {}
      let auth, appointment
      try {
        auth = JSON.parse(localStorage.getItem('auth')) || {}
      } catch {
        auth = {}
      }
      try {
        appointment = JSON.parse(localStorage.getItem('appointment')) || {}
      } catch {
        appointment = {}
      }
      commit('SET_APPOINTMENT', { appointment })
      commit('SET_AUTH', auth)
    },
    logout ({ commit }) {
      commit('SET_AUTH', {})
      commit('SET_ME', {})
      localStorage.removeItem('auth')
    }
  },
  getters: {
    actionPermissions (state) {
      /*
      настройка какие документы может создавать, удалять...
      вида {
        action: {
          app: [<model>, ...]
          ...
        },
        ...
      }
      */
      let out
      switch (state.appointment?.profession?.name) {
        case 'director':
          out = {
            add: {
              documents: ['garage', 'appointment', 'route'],
              transport: ['transport']
            },
            sign: {
              documents: ['garage', 'appointment', 'route'],
              transport: ['transport']
            },
            view: {
              documents: ['garage', 'appointment', 'route'],
              transport: ['transport']
            }
          }
          break
        case 'doctor':
          out = {
            add: {
              documents: ['medosmotr']
            },
            sign: {
              documents: ['medosmotr']
            },
            view: {
              documents: ['medosmotr', 'garage', 'appointment'],
              transport: ['transport']
            }
          }
          break
        case 'mechanic':
          out = {
            add: {
              documents: ['tehosmotr']
            },
            sign: {
              documents: ['tehosmotr']
            },
            view: {
              documents: ['tehosmotr', 'garage', 'appointment'],
              transport: ['transport']
            }
          }
          break
        default:
          out = {}
          break
      }
      return out
    },
    actionPermFilter (state, getters) {
      /*
      возвращает какие документы может создавать, удалять...
      вида {
        action: [
          {
            app: '',
            model: ''
          },
          ...
        ],
        ...
      }
      */
      const out = getters.actionPermissions
      for (const method in out) {
        const acc = []
        for (const app in out[method]) {
          out[method][app].forEach((model) => {
            acc.push({
              app,
              model
            })
          })
        }
        out[method] = acc
      }
      return out
    }
  }
})
